import { ToggleSwitch } from "flowbite-react";

type PreferenceSwitchRowProps = {
  id: string
  title: string
  description: string
  checked: boolean
  disabled: boolean
  onChange: (checked: boolean) => void
};

export const PreferenceSwitchRow = ({
  id, title, description, checked, disabled, onChange,
}: PreferenceSwitchRowProps) => (
  <div className="flex items-start justify-between gap-4 py-4">
    <div className="space-y-1">
      <label id={`${id}-title`} htmlFor={id} className="text-sm font-semibold text-gray-900 dark:text-white">{title}</label>
      <p id={`${id}-description`} className="text-sm leading-6 text-gray-600 dark:text-gray-400">{description}</p>
    </div>
    <ToggleSwitch
      id={id}
      checked={checked}
      disabled={disabled}
      onChange={onChange}
      aria-labelledby={`${id}-title`}
      aria-describedby={`${id}-description`}
      data-testid={`preference-${id}`}
    />
  </div>
);

PreferenceSwitchRow.displayName = "PreferenceSwitchRow";
